module.exports = __webpack_public_path__ + "edcf605b30d0c6a2e5773d10d0952a03.png";